import styled from 'styled-components';
import SteeringWheelIconSvg from '../../stories/assets/bus/steering-wheel.svg';

const SteeringWheelIcon = styled(SteeringWheelIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.fill};
`;

export default SteeringWheelIcon;
